export default "__VITE_ASSET__Bc2H_opL__"